<template>
	<v-snackbar
		v-model="open"
		v-bind:timeout="2000"
	>
		{{message}}
	</v-snackbar>
</template>

<script>
	export default {
		data: function(){
			var data = {
				open: false,
				message: null
			};
			return data;
		},
		created: function(){
			this.$vBus.$on("show-message", this.showMessage);
		},
		beforeDestroy: function(){
			this.$vBus.$off("show-message", this.showMessage);
		},
		methods: {
			showMessage: function(message){
				if (message == "error") {
					message = "Atsiprašome, įvyko nenumatyta klaida..."
				}
				this.open = true;
				this.message = message;
			}
		}
	};
</script>